import { Skeleton, Stack } from '@mui/material';
import React from 'react';

const TransactionDetailsSkeleton = () => {
    const numOfSkeletons = 3;
    return (
        <Stack margin={14}>
            <Skeleton variant="text" sx={{ fontSize: '1.9rem' }} />
            <Stack sx={{ marginLeft: '55px' }} spacing={2}>
                <Skeleton variant="rectangular" width={210} height={100} />
                {Array.from({ length: numOfSkeletons }).map((_, index) => (
                    <Skeleton key={index} variant="text" sx={{ fontSize: '1rem' }} />
                ))}
            </Stack>
        </Stack>
    );
};

export default TransactionDetailsSkeleton;
